import React from "react";
import Paper from "material-ui/Paper";
import Table from "material-ui/Table";
import TableBody from "material-ui/Table/TableBody";
import TableCell from "material-ui/Table/TableCell";
import TableHead from "material-ui/Table/TableHead";
import TableRow from "material-ui/Table/TableRow";

const ExceptionsTable = (props) => (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Ошибка</TableCell>
            <TableCell numeric>Частота встреч</TableCell>
            <TableCell numeric>Дата</TableCell>
            <TableCell numeric>Продукт</TableCell>
            <TableCell numeric>Id железа</TableCell>
          </TableRow>
        </TableHead>
          <TableBody>
              {props.rows && props.rows.map((row, rowIndex) => {
                  const locations = row.location || [];
                  const rowSpan = locations.length;

                  const rows = [];

                  rows.push(
                      <TableRow key={`row-${rowIndex}-0`}>
                          <TableCell rowSpan={rowSpan}>{row.message}</TableCell>
                          <TableCell rowSpan={rowSpan} numeric>{row.count}</TableCell>
                          <TableCell>{locations[0].date}</TableCell>
                          <TableCell numeric>{locations[0].product}</TableCell>
                          <TableCell numeric>{locations[0].hardwareId}</TableCell>
                      </TableRow>
                  );

                  locations.slice(1).forEach((loc, i) => {
                      rows.push(
                          <TableRow key={`row-${rowIndex}-${i + 1}`}>
                              <TableCell>{loc.date}</TableCell>
                              <TableCell numeric>{loc.product}</TableCell>
                              <TableCell numeric>{loc.hardwareId}</TableCell>
                          </TableRow>
                      );
                  });

                  return rows;
              })}
          </TableBody>
      </Table>
    </Paper>
);

export default ExceptionsTable;